"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableElement = void 0;
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var TableElement = exports.TableElement = _styledComponents["default"].table.withConfig({
  displayName: "Table__TableElement",
  componentId: "sc-evwssh-0"
})(["max-inline-size:100%;inline-size:100%;text-align:start;border-collapse:collapse;overflow-wrap:break-word;"]);